export const OTHER_BRAND = {
  id: '185',
  name: 'OTHER BRAND'
};
